// ============================================================================
// CalendarPage — a focused, full-width view of the sessions calendar for when
// the trainer wants to live in scheduling. Reuses the exact same component as
// the dashboard centrepiece, wrapped in its own live data provider so it works
// standalone (the calendar feed is shared via React Query's cache anyway).
// ============================================================================
import { useTranslation } from "react-i18next";
import { SessionsCalendar } from "../dashboard/SessionsCalendar";
import { DashboardDataProvider } from "../dashboard/DashboardDataContext";
import { TrainerCalendarSync } from "./calendar/TrainerCalendarSync";

export function CalendarPage() {
  const { t } = useTranslation();
  return (
    <DashboardDataProvider>
      <div className="space-y-6">
        <div>
          <p className="text-sm font-bold uppercase tracking-kicker text-coral">
            {t("calendar.scheduleKicker")}
          </p>
          <h1 className="mt-1 font-display text-3xl font-extrabold tracking-tightest text-body">
            {t("calendar.title")}
          </h1>
          <p className="mt-1 text-body-soft">{t("calendar.allClients")}</p>
        </div>
        <SessionsCalendar />
        {/* Sync-to-your-calendar: the trainer's read-only, auto-updating ICS feed. */}
        <TrainerCalendarSync />
      </div>
    </DashboardDataProvider>
  );
}
